import TransportationActivityShare from './TransportationActivityShare';
import AccommodationActivityShare from './AccommodationActivityShare';
import AttractionActivityShare from './AttractionActivityShare';

// Function to render the appropriate read-only activity component based on type
// nextActivityInfo: { activity, role } for "Next Stop" Google Directions link (same as PlanDetail)
export function renderActivityShare(activity, dayId, nextActivityInfo = null) {
  switch(activity.type) {
    case 'transportation':
      return (
        <TransportationActivityShare 
          activity={activity} 
          dayId={dayId} 
          nextActivityInfo={nextActivityInfo}
        />
      );
    case 'accommodation':
      return (
        <AccommodationActivityShare 
          activity={activity} 
          dayId={dayId} 
          nextActivityInfo={nextActivityInfo}
        />
      );
    default:
      // Use AttractionActivityShare as the default for any other type
      return (
        <AttractionActivityShare 
          activity={activity} 
          dayId={dayId} 
          nextActivityInfo={nextActivityInfo}
        />
      );
  }
}

export { 
  TransportationActivityShare, 
  AccommodationActivityShare, 
  AttractionActivityShare
};
